import { Button, Grid } from "@mui/material";
import { styled } from "styled-components";

const ActionButton = styled(Button)`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  padding: 12px 16px;
`;

interface IProps {
  canSave: boolean;
  onCancel: () => any;
  onSave: () => any;
  isFormDirty: boolean;
}

export const AdminActionButtons = ({ canSave, onCancel, onSave, isFormDirty }: IProps) => {
  return (
    <Grid container justifyContent="flex-end" spacing={2}>
      <Grid item>
        <ActionButton variant="outlined" onClick={onCancel} disabled={!isFormDirty}>
          Cancel
        </ActionButton>
      </Grid>
      <Grid item>
        <ActionButton variant="contained" onClick={onSave} disabled={!canSave}>
          Save changes
        </ActionButton>
      </Grid>
    </Grid>
  );
};
